import { IconPropsType } from '..';

export const PaperIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3.99992 2V18H12.7699L16.2399 14.53V2H3.99992ZM14.6399 13.872H12.1199V16.4H5.59992V3.6H14.6399V13.872ZM6.95392 13.072V11.472H10.1539V13.072H6.95392ZM6.95392 9.872V8.272H11.7539V9.872H6.95392ZM6.95392 6.672V5.072H13.3539V6.672H6.95392Z" />
  </svg>
);
